import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiTooltip from '@material-ui/core/Tooltip';
import { system700 } from 'Mui/styles/color';

const styles = ({ tooltipGap }) => ({
    tooltip: {
        fontStyle: 'Noto Sans TC',
        fontWeight: 400,
        letterSpacing: '0.4px',
        backgroundColor: system700.color
    },
    tooltipPlacementTop: {
        margin: tooltipGap
    },
    tooltipPlacementBottom: {
        margin: tooltipGap
    },
    tooltipPlacementRight: {
        margin: tooltipGap
    },
    tooltipPlacementLeft: {
        margin: tooltipGap
    }
});

/**
 * @method withTooltip - MUI Tooltip HOC Function
 * @param {Object}  props
 * @param {String}  props.tooltipText - Tooltip 的顯示文字 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top'
 * @param {String}  props.tooltipPlacement       - Tooltip 的位置 (沒顯示數字只有點) | standard (顯示數字)
 * @param {Boolean} props.disableTooltipListener - Tooltip 禁止被觸發
 * @param {Number}  props.tooltipGap             - Tooltip 跟元件的間距
 * @param {Object}  props.badgeStyle             - Tooltip 的 custom style
 * @returns {JSX.Element}
 */

function withTooltip(Component) {
    const TooltipHOC = props => {
        const {
            tooltipText = 'tooltip text',
            tooltipPlacement = 'bottom',
            disableTooltipListener = false,
            tooltipGap = 0,
            tooltipStyle,
            ...others
        } = props;
        const Tooltip = withStyles({ ...styles({ tooltipGap }), ...tooltipStyle })(MuiTooltip);

        return (
            <Tooltip
                title={tooltipText}
                placement={tooltipPlacement}
                disableFocusListener={disableTooltipListener}
                disableTouchListener={disableTooltipListener}
                disableHoverListener={disableTooltipListener}
                style={tooltipStyle}
            >
                <span
                    style={{
                        display: 'inline-block'
                    }}
                >
                    <Component {...others} />
                </span>
            </Tooltip>
        );
    };
    return TooltipHOC;
}

export default withTooltip;
